import { useState, useEffect } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useTranslation } from "react-i18next";

const CampaignHistoryFilterModal = ({
  isOpen,
  onClose,
  onApply,
  currentValue,
  title,
  options,
}) => {
  const { t } = useTranslation();
  const [selectedValue, setSelectedValue] = useState(currentValue || "all");

  useEffect(() => {
    if (isOpen) {
      setSelectedValue(currentValue || "all");
    }
  }, [isOpen, currentValue]);

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      contentClassName="rounded-lg char-modal-content"
      style={{ maxWidth: "400px" }}
      centered
    >
      <ModalHeader className="char-modal-header">
        <span className="char-modal-header-title">{title}</span>
        <button
          type="button"
          onClick={onClose}
          className="char-modal-header-close"
          aria-label={t("Close")}
        >
          <i className="fas fa-times char-modal-header-close-icon" />
        </button>
      </ModalHeader>
      <ModalBody className="char-modal-body char-modal-body--filter">
        <div className="char-status-modal-list">
          {options.map((option) => {
            const isSelected = selectedValue === option.value;

            return (
              <label
                key={option.value}
                className="char-status-modal-checkbox"
                data-status={option.value}
              >
                <input
                  type="checkbox"
                  checked={isSelected}
                  onChange={() => setSelectedValue(option.value)}
                  className="char-status-modal-checkbox-input"
                />
                <span className="char-status-modal-checkbox-label">
                  {option.label}
                </span>
              </label>
            );
          })}
        </div>
      </ModalBody>
      <ModalFooter className="char-modal-footer">
        <button type="button" onClick={onClose} className="char-button">
          {t("Cancel")}
        </button>
        <button
          type="button"
          onClick={() => {
            onApply(selectedValue);
            onClose();
          }}
          className="char-button char-button-primary"
        >
          {t("Apply")}
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default CampaignHistoryFilterModal;
